import { render } from 'preact';
import { App } from './ui/App';
import './styles.css';
import { registerServiceWorker } from './swRegistration';
import { SessionProvider } from './data/session';

registerServiceWorker();

const root = document.getElementById('app') as HTMLElement;
render(
  <SessionProvider>
    <App />
  </SessionProvider>,
  root
);
